import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=3bba1722&scoped=true&"
import script from "./Wrapper.vue?vue&type=script&lang=ts&"
export * from "./Wrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bba1722",
  null
  
)

export default component.exports